import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    search: 'Search',
  },
  de: {
    search: 'Suche',
  },
});
